export default __webpack_public_path__ + "static/media/line-icon.9af60c8c.svg";